import { call, put, select, takeLatest } from 'redux-saga/effects';
import { LOAD_USERS, UPDATE_USER } from './constants';
import {
  loadUsersSuccess,
  loadUsersError,
  updateUserSuccess,
  updateUserError,
} from './actions';

import history from 'utils/history';
import requestUtil from 'utils/request';
import requestWrapper from 'utils/requestWrapper';

import { notification } from 'antd';

export function* loadUsers() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    // we get the campaigns linked to the user
    const usersList = yield requestWrapper('GET', `users/list`, '', currentUser.token);

    if (!usersList) {
      yield put(loadUsersSuccess(false));
    } else {
      const firstElem = usersList.data[0];
      yield put(loadUsersSuccess(usersList, firstElem));
    }
  } catch (error) {
    yield put(loadUsersError(error));
  }
}

export function* updateUser(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { userDetail, actionType } = action;

    let updatedUser = false,
      isNew = !userDetail.hasOwnProperty('_id');

    if (isNew) {
      updatedUser = yield requestWrapper(
        'POST',
        'users/new/',
        userDetail,
        currentUser.token,
      );
    } else {
      updatedUser = yield requestWrapper(
        'PATCH',
        `users`,
        {
          user: userDetail,
          actionType
        },
        currentUser.token,
      );
    }
    
    if (!updatedUser) {
      yield put(updateUserSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew && updatedUser?._id) {
        notification.success({ message: 'Données enregistrées avec succès' });
        history.push({ pathname: `/utilisateurs/${updatedUser._id}` });
      }
      yield put(updateUserSuccess(updatedUser));
    }
  } catch (err) {
    yield put(updateUserError(err));
  }
}

// Individual exports for testing
export default function* usersSaga() {
  // See example in containers/HomePage/saga.js
  yield takeLatest(LOAD_USERS, loadUsers);
  yield takeLatest(UPDATE_USER, updateUser);
}
